/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountKycStatus } from './AccountKycStatus';
import {
    AccountKycStatusFromJSON,
    AccountKycStatusFromJSONTyped,
    AccountKycStatusToJSON,
} from './AccountKycStatus';
import type { Links } from './Links';
import {
    LinksFromJSON,
    LinksFromJSONTyped,
    LinksToJSON,
} from './Links';

/**
 * 
 * @export
 * @interface KycStatusOutput
 */
export interface KycStatusOutput {
    /**
     * 
     * @type {Array<AccountKycStatus>}
     * @memberof KycStatusOutput
     */
    accounts?: Array<AccountKycStatus>;
    /**
     * 
     * @type {Links}
     * @memberof KycStatusOutput
     */
    links?: Links;
    /**
     * 
     * @type {Error}
     * @memberof KycStatusOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the KycStatusOutput interface.
 */
export function instanceOfKycStatusOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KycStatusOutputFromJSON(json: any): KycStatusOutput {
    return KycStatusOutputFromJSONTyped(json, false);
}

export function KycStatusOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycStatusOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accounts': !exists(json, 'accounts') ? undefined : ((json['accounts'] as Array<any>).map(AccountKycStatusFromJSON)),
        'links': !exists(json, '_links') ? undefined : LinksFromJSON(json['_links']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function KycStatusOutputToJSON(value?: KycStatusOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accounts': value.accounts === undefined ? undefined : ((value.accounts as Array<any>).map(AccountKycStatusToJSON)),
        '_links': LinksToJSON(value.links),
        'error': value.error,
    };
}

